// extracted by mini-css-extract-plugin
export default {"SubTitle":"SubTitle_SubTitle__qhU4N","k_title":"SubTitle_k_title__ZAcBO","e_title":"SubTitle_e_title__zrsEP"};